import { defineStore } from "pinia";
import { v4 as uuid } from "uuid";

export const useClientStore = defineStore("client", () => {
  // eslint-disable-next-line no-bitwise
  const clientId = Math.floor(Math.random() * (1 << 16) * (1 << 16)).toString(16);

  return { clientId, newCorrelationId: () => clientId + uuid().substring(clientId.length) };
});
